import { DeleteOutlined, UserAddOutlined } from '@ant-design/icons';
import { Modal, Button, Row, Col, notification } from 'antd';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormularioNovoTerminal from '../app/features/FormularioNovoTerminal';

const ModalT = (props: { quandoFinalizar: () => any; idEmissor: string }) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Form de cadastro de usuários');
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);
  const params = useParams<{ id: string }>();

  return (
    <>
      <Row align={'middle'}>
        <Col xs={24} lg={12} style={{ marginTop: '10px' }}>
          {!props.idEmissor ? (
            <Button
              type='primary'
              disabled
              onClick={openCreationModal}
              icon={<UserAddOutlined />}
            >
              Terminais
            </Button>
          ) : (
            <Button type='primary' onClick={openCreationModal} icon={<UserAddOutlined />}>
              Terminais
            </Button>
          )}
        </Col>
      </Row>
      <Modal
        title='Terminais'
        footer={null}
        visible={showCreationModal}
        onCancel={closeCreationModal}
        destroyOnClose
      >
        <FormularioNovoTerminal
          onSuccess={() => {
            closeCreationModal();
            props.quandoFinalizar();

            notification.success({
              message: 'Terminal cadastrado com sucesso',
              top: 80,
            });
          }}
          idEmissor={props.idEmissor}
        ></FormularioNovoTerminal>
      </Modal>
    </>
  );
};

export default ModalT;
